import {
  User, Sliders, Image, ArrowRight, ArrowLeft, Check, AlertTriangle, AlertCircle, CheckCircle,
  Search, Eye, EyeOff, Users, Home, ChevronDown, ChevronUp, Menu, Settings, Zap, UserPlus, LogOut,
  Calendar, X, UploadCloud, Trash2, ChevronRight, ChevronLeft, Circle, Disc, Filter, Copy,
  ArrowUp, ArrowDown, Minus, File, Phone, Info, Download,
} from 'react-feather';

// Importing custom svg icons
import {
  Dashboard, OtherPen, Menu2, ApiIcon, PhoneCallIcon,
} from '../../icons';

const IconMap = {
  DASHBOARD: Dashboard,
  OTHER_PEN: OtherPen,
  MENU_2: Menu2,
  EYE: Eye,
  USER: User,
  ADJUST: Sliders,
  ARROW_RIGHT: ArrowRight,
  ARROW_LEFT: ArrowLeft,
  ARROW_UP: ArrowUp,
  ARROW_DOWN: ArrowDown,
  CHECK: Check,
  ALERT_TRIANGLE: AlertTriangle,
  ALERT_CIRCLE: AlertCircle,
  CHECK_CIRCLE: CheckCircle,
  SEARCH: Search,
  SHOW_PASSWORD: Eye,
  HIDE_PASSWORD: EyeOff,
  USERS: Users,
  HOME: Home,
  CHEVRON_UP: ChevronUp,
  CHEVRON_DOWN: ChevronDown,
  CHEVRON_RIGHT: ChevronRight,
  CHEVRON_LEFT: ChevronLeft,
  MENU: Menu,
  SETTINGS: Settings,
  ZAP: Zap,
  USER_PLUS: UserPlus,
  LOGOUT: LogOut,
  CALENDAR: Calendar,
  CROSS: X,
  UPLOAD: UploadCloud,
  DELETE: Trash2,
  CIRCLE: Circle,
  DISC: Disc,
  FILTER: Filter,
  MINUS: Minus,
  COPY: Copy,
  FILE: File,
  PHONE: Phone,
  API_ICON: ApiIcon,
  PHONE_CALL: PhoneCallIcon,
  INFO: Info,
  DOWNLOAD: Download,
};

// Deriving IconTypes from IconMap to keep a single list and have a single source of truth
const IconTypes = Object.keys(IconMap).reduce((acc, key) => ({ ...acc, [key]: key }), {});

export {
  IconMap as default,
  Image as DefaultIcon,
  IconTypes,
};
